/* SetDefaultConfigAction.js */

"use strict";

class SetDefaultConfigAction {
    constructor(logger, gameEditor, DeviceEntity, userSession, userFeedback) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._DeviceEntity = DeviceEntity;
        this._userSession = userSession;
        this._modalUserFeedback = userFeedback;
        this._message = "Are you sure you want to set the latest captured configuration as the default configuration for this device?\n";
        this.run = this.run.bind(this);
    }

    run() {
        let workInputs = {};
        return this._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: this._message,
                title: "Set Default Configuration",
                confirmDetails: {
                    text: "Confirm",
                    type: "additive"
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text"
                }
            },
            () => {
                let workTarget = {
                    method: "single",
                    id: this._gameEditor.getDevice()._id
                };
                return this._DeviceEntity
                    .runSetLatestConfigAsStableWork(this._userSession.activeOrganization.id, workTarget, workInputs, { launchAndForget: true })
                    .catch((err) => {
                        this._logger.warn({ error: err }, "SetDefaultConfigAction.run() - Error");
                        return this._modalUserFeedback.displayError(err);
                    });
            }
        );
    }
}

module.exports = SetDefaultConfigAction;

SetDefaultConfigAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "$teve.entities.Device", "$teve.userSession", "$teve.ui.userFeedback"];

SetDefaultConfigAction.$displayDetails = {
    type: "Action",
    name: "SetDefaultConfigAction",
    icon: "common.star",
    shown: true,
    title: "Set Default Configuration",
    order: 3
};
